<template>
    <div class="minor-tabs">
        <div class="minor-tabs__container display-flex align-items-center">
            <div
                v-for="tab in props.tabs"
                :key="tab.id"
                class="minor-tabs__tab pt-sm px-sm pb-xs mr-lg display-flex align-items-center"
                :class="{ 'minor-tabs__tab--selected': tab.id === selectedTabId }"
                @click="onTabClicked(tab.id)"
            >
                <p class="minor-tabs__title font-bold text-dark">{{ tab.text }}</p>
                <font-awesome-icon
                    v-if="props.showWarningId === tab.id"
                    v-tooltip="{
                        content: 'Changes made in Technology Areas will effect the Benchmark Peers',
                    }"
                    :icon="`fas fa-circle-info`"
                    class="minor-tabs__icon text-info ml-sm"
                    size="lg"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const emit = defineEmits(['tab-clicked'])
const props = defineProps({
    tabs: {
        type: Array,
        default: () => [
            {
                title: 'Tab 1',
                id: 1,
            },
            {
                title: 'Tab 2',
                id: 2,
            },
        ],
    },
    currentMinorTab: {
        type: Number,
        default: 1,
    },
    showWarningId: {
        type: Number,
        default: null,
    },
})

const selectedTabId = computed(() => {
    return props.currentMinorTab ? props.currentMinorTab : props.tabs[0].id
})

const onTabClicked = (id) => {
    emit('tab-clicked', id)
}
</script>

<style lang="scss" scoped>
.minor-tabs {
    &__container {
        display: flex;
    }

    &__tab {
        background: var(--color-stone-200);
        border-radius: var(--border-radius-sm);
        cursor: pointer;
        transition: all 0.3s ease-in-out;

        .minor-tabs__title {
            color: var(--color-stone-800);
        }

        &--selected {
            background: var(--color-stone-800);

            .minor-tabs__title {
                color: var(--color-text-on-dark);
            }

            .minor-tabs__icon {
                color: var(--color-text-on-dark) !important;
            }
        }

        &:hover {
            background: var(--color-stone-400);
        }
    }
}
</style>
